<script setup lang="ts">
const { footerData } = useGlobalState()
const data = unref(footerData)
const route = useRoute()
const currentRoute = computed(() => route.path)
</script>

<template>
  <footer class="text-neon-yellow relative bg-black pt-16 max-lg:z-1000 lg:pt-30 lg:pb-16">
    <div class="lg:grid lg:grid-cols-[1fr_auto_1fr]">
      <IconsN class="w-55 max-lg:hidden" />

      <nav
        class="font-display text-neon-yellow grid content-center items-center justify-center justify-items-center gap-2 text-center text-xl uppercase font-stretch-expanded"
      >
        <CommonBasicLink
          v-for="(link, index) in data?.mainMenu"
          :key="index"
          :link="link"
          class="main-link group before:bg-neon-yellow relative flex items-center gap-2 px-3 py-2 before:absolute before:-inset-0 before:z-[0] before:transition-all before:duration-300 before:ease-out before:content-[''] lg:hover:text-(--color-black) lg:hover:before:scale-x-[1.1] lg:hover:before:-skew-x-[20deg]"
        >
          <span
            v-if="currentRoute === link.page?.url || currentRoute === link.url"
            class="logomark bg-neon-yellow relative block h-[.65lh] w-3 -skew-x-[20deg] transition-all group-hover:bg-black"
          />
          <span class="relative z-[1] block">
            {{ link.title }}
          </span>
        </CommonBasicLink>

        <ElementsButton
          v-if="data?.loginLink"
          :link="data?.loginLink"
          class="before:bg-neon-yellow !font-display mt-2 text-center text-xl text-black uppercase font-stretch-expanded"
        />
      </nav>

      <IconsX class="ml-auto w-55 max-lg:hidden" />
    </div>

    <div
      class="px-bleed grid gap-5 pt-20 font-mono text-xs uppercase max-lg:text-center lg:grid-cols-[1fr_auto_1fr] lg:items-center"
    >
      <p>© 2025 Nitex Inc. All rights Reserved.</p>

      <nav class="flex justify-center gap-2 max-lg:-order-1">
        <!-- socials -->
        <NuxtLink
          v-for="(socialMedia, index) in data?.socialMedias"
          :key="index"
          :href="socialMedia.url"
          target="_blank"
          :aria-label="socialMedia.title || socialMedia.url"
          class="social-logo border-neon-yellow lg:hover:bg-neon-yellow flex aspect-square h-8 items-center justify-center border p-1 transition-colors"
        >
          <div v-dompurify-html="socialMedia.svgIcon" />
        </NuxtLink>
      </nav>

      <nav class="flex justify-center gap-6 lg:justify-end">
        <CommonBasicLink
          v-for="(link, index) in data?.additionalLinks"
          :key="index"
          :link="link"
          class="before:bg-neon-yellow before:transition-width relative before:absolute before:bottom-0 before:left-1/2 before:z-[0] before:h-[1px] before:w-0 before:origin-center before:translate-x-[-50%] before:duration-300 before:ease-out before:content-[''] lg:hover:before:w-full"
        >
          {{ link.title }}
        </CommonBasicLink>
      </nav>
    </div>

    <div class="flex justify-between pt-21 lg:hidden">
      <IconsN class="w-28" />
      <IconsX class="w-28" />
    </div>
  </footer>
</template>
<style scoped>
.main-link:before {
  /* clip-path: polygon(60% 0, 60% 0, 40% 100%, 40% 100%); */
  clip-path: polygon(50% 0, 50% 0, 50% 100%, 50% 100%);
}
@media (min-width: 900px) {
  .main-link:hover:before {
    /* clip-path: polygon(0% 0%, 125% 0%, 100% 100%, -25% 100%); */
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
}
.social-logo:deep(svg) path {
  transition: all 0.15s ease-in-out;
}
.social-logo:hover:deep(svg) path {
  @media (min-width: 900px) {
    fill: var(--color-black);
  }
}
</style>
